module.exports = __webpack_public_path__ + "img/premium_banner.7641e7bd.jpg";